module.exports = __webpack_public_path__ + "gm992021/img/douluo-5.png?d81c88c8";